<section class="section-white padd-t-96 padd-m-lr-0">
  <div class="section-container padd-mob-lr-0 mar-mob-t-0">
    <img
      src="{{ heroData?.image?.url }}"
      alt="{{ heroData?.image?.alt }}"
      class="rounded mob-no-rounded"
    />
    <div class="c_converter" [hidden]="isUnsupportedCurrency">
      <div class="cur_cal right-side">
        <div class="converer-row">
          <div class="col first-col">
            <div class="input_one input_set">
              <input
                type="text"
                #inAmount
                placeholder="Enter Amount"
                (input)="collectValue($event)"
              />
              <country-list
                [selectedCountry]="selectedCountryCode1"
                [countryList]="currencies"
                [align]="'right'"
                (changedCountryCode)="changeSelectedCountryCode1($event)"
              ></country-list>
            </div>
          </div>
          <div class="col f-0 icon-col">
            <button class="toggle_cont btn-null" (click)="invertCurrency()">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M29 8.97229C29 8.70563 28.8933 8.45229 28.7067 8.26562L23.7467 3.30563C23.36 2.91896 22.72 2.91896 22.3333 3.30563C21.9467 3.69229 21.9467 4.33229 22.3333 4.71896L25.6 7.98562H4C3.45333 7.98562 3 8.43896 3 8.98563C3 9.53229 3.45333 9.97229 4 9.97229H25.5867L22.3333 13.2256C21.9467 13.6123 21.9467 14.2523 22.3333 14.639C22.5333 14.839 22.7867 14.9323 23.04 14.9323C23.2933 14.9323 23.5467 14.839 23.7467 14.639L28.6933 9.69229C28.7867 9.59896 28.8667 9.47896 28.92 9.34563C28.92 9.33229 28.92 9.31896 28.9333 9.30563C28.9733 9.19896 29 9.09229 29 8.97229Z"
                  fill="#969CA4"
                />
                <path
                  d="M28 22.027H6.41333L9.66667 18.7736C10.0533 18.387 10.0533 17.747 9.66667 17.3603C9.28 16.9736 8.64 16.9736 8.25333 17.3603L3.30667 22.307C3.21333 22.4003 3.13333 22.5203 3.08 22.6536C3.08 22.667 3.08 22.6803 3.06667 22.6936C3.02667 22.8003 3 22.9203 3 23.0403C3 23.307 3.10667 23.5603 3.29333 23.747L8.25333 28.707C8.45333 28.907 8.70667 29.0003 8.96 29.0003C9.21333 29.0003 9.46667 28.907 9.66667 28.707C10.0533 28.3203 10.0533 27.6803 9.66667 27.2936L6.4 24.027H28C28.5467 24.027 29 23.5736 29 23.027C29 22.4803 28.5467 22.027 28 22.027Z"
                  fill="#969CA4"
                />
              </svg>
              <svg
                class="mobile-only"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M5.48683 1.66668C5.31578 1.66668 5.15329 1.73505 5.03355 1.85471L1.85203 5.0342C1.60401 5.28206 1.60401 5.69232 1.85203 5.94018C2.10005 6.18804 2.51057 6.18804 2.75859 5.94018L4.85395 3.84616L4.85395 17.6923C4.85395 18.0427 5.14473 18.3333 5.49539 18.3333C5.84604 18.3333 6.12827 18.0427 6.12827 17.6923L6.12827 3.85471L8.21507 5.94018C8.46309 6.18804 8.87361 6.18804 9.12163 5.94018C9.24992 5.81197 9.30979 5.64958 9.30979 5.48719C9.30979 5.32479 9.24992 5.1624 9.12163 5.0342L5.94867 1.86326C5.8888 1.80343 5.81183 1.75215 5.7263 1.71796C5.71775 1.71796 5.7092 1.71796 5.70065 1.70941C5.63223 1.68377 5.56381 1.66668 5.48683 1.66668Z"
                  fill="#CACED1"
                />
                <path
                  d="M13.8591 2.3077L13.8591 16.1453L11.7723 14.0598C11.5242 13.812 11.1137 13.812 10.8657 14.0598C10.6177 14.3077 10.6177 14.718 10.8657 14.9658L14.0387 18.1368C14.0985 18.1966 14.1755 18.2479 14.261 18.2821C14.2696 18.2821 14.2781 18.2821 14.2867 18.2906C14.3551 18.3162 14.4321 18.3333 14.5091 18.3333C14.6801 18.3333 14.8426 18.265 14.9623 18.1453L18.1439 14.9658C18.2721 14.8376 18.332 14.6752 18.332 14.5128C18.332 14.3504 18.2721 14.188 18.1439 14.0598C17.8958 13.812 17.4853 13.812 17.2373 14.0598L15.1419 16.1539L15.1419 2.3077C15.1419 1.95727 14.8512 1.66668 14.5005 1.66668C14.1499 1.66668 13.8591 1.95727 13.8591 2.3077Z"
                  fill="#CACED1"
                />
              </svg>
            </button>
          </div>
          <div class="col">
            <div class="input_one input_set">
              <input type="text" [(ngModel)]="outAmount" />
              <country-list
                [selectedCountry]="selectedCountryCode2"
                [countryList]="currencies"
                [align]="'right'"
                (changedCountryCode)="changeSelectedCountryCode2($event)"
              ></country-list>
            </div>
          </div>
          <div class="col f-0">
            <button class="btn btn-full cal_btn" (click)="sendNow()">
              Send now
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p class="d-inline-block me-5 mb-0" *ngIf="gbpChange">
              1 {{ currencyFrom }} =
              <strong
                >{{ gbpChange?.rateAfterSpread | number: '1.4' }}
                {{ currencyTo }}</strong
              >
              Last updated {{ today | date: 'long' }}
            </p>
            <p class="ms-5 mb-0 d-inline-block text-light">
              We use midmarket rates
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
